import React, {
  useEffect,
  useState,
} from 'react';

import { communicationAPI } from 'api/communicationAPI';
import SearchIcon from 'assets/images/icon/SearchIcon';
import { cloneDeep } from 'lodash';
import ReactSlider from 'react-slider';
import { useRecoilValue } from 'recoil';
import { userInfo } from 'state';
import styled from 'styled-components';
import { isEmpty } from 'util/isEmpty';
import {
  DropdownMenu,
  Overlay,
  Pagenation,
} from 'view/components';
import { CheckBox } from 'view/components/common/CheckBox';
import CoPopup from 'view/pages/Communication/components/CoPopup';
import ListItem from 'view/pages/Communication/components/ListItem';
import EmptyBox from "../../../components/common/EmptyBox";
import {classesAPI} from "../../../../api/classesAPI";
import {fadeIn, fadeIn3} from "../../../../styled/StyledComponent";
import SearchInputItem from "../../../components/common/SearchInputItem";

const Homework = (props) => {
    const [list, setList] = useState([]);
    const [classList, setClassList] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const [selectClass, setSelectClass] = useState(null);
    const [completed, setCompleted] = useState(true);
    const [received, setRceived] = useState(true);
    const [loading, setLoading] = useState(false);
    const [indexValue, setIndexValue] = useState({
        i:0,
        v:5
    })
    const [Popup, setOnPopup] = useState(false);
    const [pageInfo, setPageInfo] = useState({
        totalPages: 0,
        number: 0,
        size: 5,
    });
    const user = useRecoilValue(userInfo);

    const getHomeworkList = async (pageNumber) => {
        setLoading(true)
        try {
           await communicationAPI
                .getHomeworkList({
                    params: {

                        classesId: !isEmpty(selectClass?.id) ? selectClass?.id : "",
                        isReceived: received === true && completed === true ? "" : received,
                        isCompleted: received === true && completed === true ? "" : !received,
                        paged: true,
                        page: pageNumber,
                        size: 5,
                        // gradeFrom:0,
                        // gradeTo:indexValue.v

                    },
                })
                .then((res) => {
                    console.log("homework", res);
                    setList(cloneDeep(res?.data?.content));
                    setPageInfo({
                        totalPages: res?.data?.totalPages,
                        number: res?.data?.number,
                        size: res?.data?.size,
                    });
                    setLoading(false)
                });
        }catch (e) {
            setLoading(false)

        }
    };
    const getClassItem = async () => {
        const result = await classesAPI
            .getClassList({
                params:{
                    size: 100,
                    // progress:categoryParams?.params,
                }
            })
            .then((res) => {
                setClassList(cloneDeep(res?.data?.content));
                return res?.data?.content;
            });
        return result;
    };
    const getClassItems = () => {
        console.log("@user",classList);
        const c = cloneDeep(classList);
        const arr = c
            ?.map((item) => {
                return {
                    ...item,
                    dropdownItem: item?.classTitle || "",
                };
            })
            .filter((filterItem) => {
                return filterItem?.progress === "PUBLISHED";
            });
        return arr || [];
    };

    const onClickDropdown = (item: any, key: string, index, obj) => {
        let selectItem;
        console.log("obj", obj);
        if (!isEmpty(obj)) {
            const copy = cloneDeep(obj);
            delete copy.dropdownItem;
            selectItem = copy;
        } else {
            selectItem = item;
        }
        console.log("selectItem", selectItem);
        setSelectClass(cloneDeep(selectItem));
    };

    const onClickGetData = (item) => {
        setSelectedData(cloneDeep(item));

        setOnPopup(true);
    };

    const onClickMovePage = (isNext) => {
        const c = cloneDeep(pageInfo);
        if (isNext) {
            if (pageInfo?.number + 1 === pageInfo?.totalPages) return;
            c.number = c.number + 1;
        } else {
            if (pageInfo?.number === 0) return;
            c.number = c.number - 1;
        }
        setPageInfo(c);
    };

    useEffect(() => {
        getHomeworkList(0);
    }, [completed, received]);

    useEffect(() => {
        getHomeworkList(pageInfo?.number);
    }, [pageInfo.number]);

    useEffect(() => {
        getHomeworkList(0);
    }, [indexValue?.v]);

    useEffect(() => {
        getHomeworkList(0);
    }, [selectClass?.id]);

    useEffect(()=>{
        getClassItem()
    },[])

    console.log("list", list);
    console.log("user", user);
    console.log('indexValue', indexValue)
    return (
        <Container>
            {Popup && !isEmpty(selectedData) && (
                <Overlay filter={true}>
                    <CoPopup
                        data={selectedData}
                        userData={user}
                        onClickPopup={() => {
                            setOnPopup((v) => !v);
                            getHomeworkList(pageInfo?.number);
                        }}
                    />
                </Overlay>
            )}
            {Popup && (
                <Overlay filter={true}>
                    <CoPopup
                        data={selectedData}
                        userData={user}
                        onClickPopup={() => {
                            setOnPopup((v) => !v);
                            getHomeworkList(pageInfo?.number);
                        }}
                    />
                </Overlay>
            )}
            <ContentsInner>
                <Status>
                <StatusCheck>
                    <p>Status:</p>
                    <CheckItem>
                        <CheckBox
                            onClick={() => {
                                if (received) {
                                    setCompleted(true);
                                }
                                setRceived((v) => !v);
                            }}
                            state={received}
                        />
                        <span>Received</span>
                    </CheckItem>
                    <CheckItem>
                        <CheckBox
                            onClick={() => {
                                if (completed) {
                                    setRceived(true);
                                }
                                setCompleted((v) => !v);
                            }}
                            state={completed}
                        />
                        <span>Completed</span>
                    </CheckItem>
                </StatusCheck>
                <Slider>
                 <h5>Grades:</h5>
                <SliderWrap>
                <ReactSlider
                    withTracks={true}
                    className="horizontal-slider"
                    marks={[...[1,2,3,4].slice(0,indexValue.v),5]}
                    markClassName="mark"
                    thumbActiveClassName={"active"}
                    onChange={(val, index)=>{
                        console.log('val', val, index)
                        setIndexValue({
                            i:index,
                            v:val
                        })
                    }}
                    value={indexValue.v}
                    min={1}
                    max={5}
                    // renderMark={props => {
                    //     console.log('props', props)
                    //     return(<div className='indexItem' {...props} ><span>{`${props?.key}`}</span></div>)
                    // }}
                    thumbClassName="thumb"
                    trackClassName="track"
                    renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
                />
                <IndexItems>
                    <span>1</span>
                    <span>2</span>
                    <span>3</span>
                    <span>4</span>
                    <span>5</span>
                </IndexItems>
            </SliderWrap>
            </Slider>
                </Status>           
                <SearchArea style={{ marginBottom: 15 }}>
                    <DropDownArea>
                        <DropDownWrap style={{width:"50%"}}>
                            <DropdownMenu
                                selected={selectClass?.classTitle || ""}
                                altText="All classes"
                                borderColor={"#E5E5E5"}
                                height={40}
                                onClick={onClickDropdown}
                                items={[...getClassItems(), { dropdownItem: "All" }]}
                            />
                        </DropDownWrap>
                        {/*<DropDownWrap*/}
                        {/*    className={"newest"}*/}
                        {/*    style={{opacity:0, pointerEvents:"none"}}*/}
                        {/*>*/}
                        {/*    <DropdownMenu*/}
                        {/*        selected={""}*/}
                        {/*        altText="Newest"*/}
                        {/*        borderColor={"#E5E5E5"}*/}
                        {/*        height={40}*/}
                        {/*        items={[]}*/}
                        {/*    />*/}
                        {/*</DropDownWrap>*/}
                    </DropDownArea>
                    <SearchInputItem/>
                </SearchArea>

                <Wrap>
                    {!isEmpty(list) &&
                        !isEmpty(user) &&
                        list?.map((item, index) => {
                            return (
                                <ListWrap index={0.3}>
                                    <ListItem
                                        userData={user}
                                        onClickPopup={onClickGetData}
                                        data={item}
                                    />
                                </ListWrap>
                            );
                        })}
                    {
                        isEmpty(list) && loading == false &&
                        <EmptyBox url={"/images/nothing.png"} />
                    }
                </Wrap>

            </ContentsInner>
            <Pagenation
                totalPage={pageInfo?.totalPages}
                onClickMove={(isNext) => {
                    onClickMovePage(isNext);
                }}
                size={pageInfo?.size}
                pageNumber={pageInfo?.number}
            />
        </Container>
    );
};
export default Homework;

const Container = styled.div`
    height: 100%;
    position: relative;
    animation: ${fadeIn} 0.4s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
`;

const ContentsInner = styled.div`
    padding: 20px;
    overflow: hidden;
    position: relative;
    min-height: 550px;
    height: 100%;
`;
const Status = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media screen and (max-width: 768px) {
        flex-direction: column;
        & > div{
            width: 100%;
        }
    }
`; 
const Wrap = styled.div`
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;

    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
    }
`;
const ListWrap = styled.div<{index?:any}>`
    animation: ${fadeIn3} ${props => props.index}s linear;
`
const StatusCheck = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    p {
        margin-right: 15px;
        font-weight: 700;
        color: "#333";
        font-size: 18px;
    }
`;
const SearchArea = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 30px;
    @media screen and (max-width: 768px) {
        flex-direction: column;
        & > div{
            width: 100%;
        }
    }
`;
const DropDownArea = styled.div`
    display: flex;
    width: 50%;
    @media screen and (max-width: 768px) {
        width: 100%;
        & > div {
            width: 100%!important;
            margin-right: 0!important;
        }
    }
`;
const InputArea = styled.div`
    width: 37%;
    display: flex;
    height: 40px;
    border-radius: 8px;
    overflow: hidden;
    align-items: center;
    flex-direction: row;
    &:hover{
        & > div{
            background: #d5d5d5;

        }
    }
    div {
        transition: all 0.2s;
        
        height: 100%;
        box-sizing: border-box;
        padding: 0 8px;
        background: #e5e5e5;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        svg {
            padding-bottom: 3px;
        }
        span {
            font-weight: 700;
            font-size: 16px;
            margin-left: 8px;
        }
    }
    input {
        padding-left: 15px;
        outline: none;
        display: flex;
        height: 100%;
        width: 100%;
        flex: 1;
        border-radius: 8px 0 0 8px;
        border: solid 1px #e5e5e5;
        border-right: none;
        &::placeholder {
            opacity: 0.5;
        }
    }
`;
const DropDownWrap = styled.div`
    width: 100%;
    margin-right: 15px;
    @media screen and (max-width: 768px) {
        
        margin-bottom: 16px;
        &.newest{
            margin-right: 0!important;
        }
    }
`;
const CheckItem = styled.div`
    span {
        margin-left: 5px;
        font-weight: 400;
        font-size: 18px;
    }
    margin-right: 15px;
    display: flex;
    align-items: center;
`;
const Slider = styled.div`
 display: flex;
 align-items: flex-start;
 margin-bottom: 10px;
    width: 50%;
    @media screen and (max-width: 875px) {
        flex-wrap: wrap;
    }
    @media screen and (max-width: 768px) {
        margin-bottom: 16px;
        flex-wrap: nowrap;
        &.newest{
            margin-right: 0!important;
        }
    }
 h5{
    font-weight: 700;
    font-size: 18px;
    transform: translate(0px, -7px);
     margin-right: 16px;
 }
`; 
const IndexItems = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 6px 0 6px;
    margin-top: 16px;
    span{
        text-align: center;
                display: flex;
                font-weight: 400;
                font-size: 14px;
                display: flex;
                justify-content: center;
            }
`; 
const SliderWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    .horizontal-slider {
        display: flex;
        align-items: center;
        
        .active{
            width: 16px;
            height: 16px;
            
        }
        span {
            &:nth-child(1) {
                background: #fff;
                
            }
        }
        .mark {
            height: 16px;
            width: 16px;
            border-radius: 50%;
            background: #333;
            display: flex;
            align-items: center;
            justify-content: center;
           
            .indexItem{
                transform: translateY(10px);
            }
            &:first-of-type {
                background: #fff;
                border: solid 2px #333;
            }
            &:last-of-type {
                background: #fff;
                border: solid 2px #333;
            }
         
        }
        .track {
            height: 8px;
            border-radius: 6px;
            background: #3333331a;
        }
        .track-0 {
            background: #333333;
        }
        .mark{
            display: none;
            &:nth-of-type(1){
                display: flex;
            }
        }
        .thumb {
            outline: none;
            cursor: pointer;
            border-radius: 100%;
            height: 16px;
            width: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #111;
        }
    }
`;
